<template>
  <span class="inline-block bg-red-100 rounded-full" :class="{...classes}">{{ displayValue }}</span>
</template>

<script>
export default {
  name: 'PdlBadge',
  props: {
    /**
     * 'max' will cap the value and concat the 'value' prop with '+'
     */
    max: {
      type: Number,
      default: 99,
      validator: (value) => {
        return value > 0 && Number.isInteger(value);
      },
    },
    /**
     * Numeral to display in the badge
     */
    value: {
      type: Number,
      default: null,
      validator: (value) => {
        return value >= 0 && Number.isInteger(value);
      },
    },
  },
  computed: {
    classes() {
      return {
        'pdl-badge': !this.value || this.value == 0,
        'pdl-badge-numerical text-xs text-white font-bold text-center leading-none': this.value && this.value !== 0,
      };
    },
    displayValue() {
      if (!this.value || this.value == 0) {
        return null;
      }
      if (this.max && this.value > this.max) {
        return `${this.max}+`;
      }
      return this.value;
    },
  },
};
</script>

<style lang="scss">
@import 'Badge.scss';
</style>
